import { render, staticRenderFns } from "./markdown-field.vue?vue&type=template&id=1e8a44d1&"
import script from "./markdown-field.vue?vue&type=script&lang=js&"
export * from "./markdown-field.vue?vue&type=script&lang=js&"
import style0 from "./markdown-field.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VIcon,VSlideYTransition})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e8a44d1')) {
      api.createRecord('1e8a44d1', component.options)
    } else {
      api.reload('1e8a44d1', component.options)
    }
    module.hot.accept("./markdown-field.vue?vue&type=template&id=1e8a44d1&", function () {
      api.rerender('1e8a44d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/markdown-field/markdown-field.vue"
export default component.exports